// extracted by mini-css-extract-plugin
module.exports = {"tampa-web-map":"about-page_tampa-web-map__tzIa1","figure":"about-page_figure__2GPF-","fun-facts-wrapper":"about-page_fun-facts-wrapper__27buO"};